import { render, staticRenderFns } from "./DocumentPicker.vue?vue&type=template&id=2a34d00c&scoped=true"
import script from "./DocumentPicker.vue?vue&type=script&lang=ts"
export * from "./DocumentPicker.vue?vue&type=script&lang=ts"
import style0 from "./DocumentPicker.vue?vue&type=style&index=0&id=2a34d00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a34d00c",
  null
  
)

export default component.exports